
import { gql } from '@apollo/client';

export const GET_COURSE = gql`
  query Courses($courseId: Int!) {
    course(courseId: $courseId) {
      id
      name
      classRecords {
        id
        userId
        connectionScore
        contributionScore
        endCapacityScore
        startCapacityScore
        confidenceScore
        completionStatus
        teacherComment
        notes
      }
      courseParticipantCount
      usersWithRecords {
        id
        name
        identifier
        photoUrl
      }
      participants {
        id
        name
        identifier
        photoUrl
      }
    }
  }`;
